import { Dialog } from "@/components/shared/dialog";
import { useMemo } from "react";
import styles from "./styles.module.scss";
import { CrossCircledIcon } from "@radix-ui/react-icons";
import { Button } from "@radix-ui/themes";
import { useExploreApi } from "@/v2/entities/explore/Explore.api";
import { useMutation, useQueryClient } from "react-query";
import { ExploreView } from "@/v2/entities/explore/Explore.model";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

interface DeleteExploreViewDialogProps {
  open: boolean;
  view: ExploreView;
  onClose: () => void;
}

export function DeleteExploreViewDialog({
  open,
  view,
  onClose,
}: DeleteExploreViewDialogProps) {
  const navigate = useNavigate();

  const queryClient = useQueryClient();
  const { deleteView } = useExploreApi();

  const {
    mutate: deleteViewMutation,
    isLoading,
    error,
  } = useMutation({
    mutationFn: () =>
      deleteView(view.id).then(() => {
        queryClient.invalidateQueries(["explore-views"]);
        onClose();
        navigate("/explore/views");
        toast.success("View deleted successfully");
      }),
  });

  const errorMessage = useMemo<string | undefined>(() => {
    if (error != null) {
      return (error as { message: string }).message;
    }
  }, [error]);

  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <Dialog.Content size={"small"}>
        <Dialog.Title>
          Delete AI Instance
          <Dialog.Close />
        </Dialog.Title>

        <div className={styles.DeleteSimulatorDialog}>
          <div className={styles.Content}>
            Are you sure you want to delete "{view.title}" ?
          </div>

          {errorMessage != null && (
            <div className={styles.ErroMessage}>
              <CrossCircledIcon />
              {errorMessage}
            </div>
          )}

          <div className={styles.Footer}>
            <Button
              color={"red"}
              variant={"solid"}
              size={"1"}
              loading={isLoading}
              disabled={errorMessage != null}
              onClick={() => {
                deleteViewMutation();
              }}
            >
              Delete
            </Button>

            <Button
              color={"gray"}
              variant={"ghost"}
              size={"1"}
              disabled={isLoading}
              onClick={onClose}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Dialog.Content>
    </Dialog>
  );
}
